import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

const Close = (props) => <CloseIcon {...props} />;

export default Close;
